import { BaseWebComponentDataProvider } from '../../../../../framework/BaseWebComponentDataProvider';
import { InProductTrialsAdditionalUserSettings } from '../types/InProductTrialsAdditionalUserSettings';

export abstract class InProductTrialsOverlayWindowsAppBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getAdditionalUserSettingsForInProductTrials(): Promise<InProductTrialsAdditionalUserSettings>;
}
